
  (function(){
    const carousel = document.getElementById('carousel');
    const items = carousel.querySelectorAll('.carousel-item');
    const dots = document.querySelectorAll('.carousel-dots .dot');
    let currentIndex = 0;

    function updateCarousel() {
      const itemWidth = items[0].offsetWidth + 24; // 24px gap (1.5rem)
      carousel.scrollLeft = currentIndex * itemWidth;

      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[currentIndex]) dots[currentIndex].classList.add('active');
    }

    function autoScroll() {
      currentIndex = (currentIndex + 1) % items.length;
      updateCarousel();
    }

    let scrollInterval = setInterval(autoScroll, 3000);

    // Pause on hover
    carousel.addEventListener('mouseenter', () => clearInterval(scrollInterval));
    carousel.addEventListener('mouseleave', () => {
      scrollInterval = setInterval(autoScroll, 3000);
    });

    // Dot click event
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        currentIndex = parseInt(dot.dataset.index);
        updateCarousel();
      });
    });

    // Initialize state
    updateCarousel();
  })();

